import { Spinner } from 'src/common/components/Spinner';

export default Spinner;
